import Vue from 'vue'
import VueRouter from 'vue-router'
import newexcel from '../views/newexcel.vue'
import HomeViewVue from '@/views/HomeView.vue'
import focusVue from '@/views/focus.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'newexcel',
    component: newexcel
  } 
]

const router = new VueRouter({
  routes
})

export default router
